const _UTILS = {
  async AddItemsToCart(items_to_add, sections) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items: items_to_add, 
        sections: sections 
      }),
    })
  },
  RefreshCart(cart_event_data) {
    console.log(cart_event_data)
    document.documentElement.dispatchEvent(new CustomEvent('switch:cart:afteradditem', {
      detail: {response: cart_event_data},
      bubbles: true
    }));
    Alpine.store('modals').open('cart');
  },
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('SwiperImageSlideshow', () => ({
    settings: {},
    slides: [],
    init() {
      this.InitSelf();
      this.InitSwiper();
    },
    InitSelf() {
      let am = this;
      am.settings = JSON.parse(am.$el.dataset.settings);
      am.slides = JSON.parse(am.$el.dataset.slides);
      console.log(am.settings, am.slides)
    },
    InitSwiper() {
      let am = this;
      let sw_options = {
        navigation: {
          nextEl: am.$el.querySelector('.swiper-button-next'),
          prevEl: am.$el.querySelector('.swiper-button-prev'),
        },
        loop: true,
        centeredSlides: true,
        speed: 500,
      }
      if (am.settings.auto_rotate) {
        sw_options.autoplay = {
          delay: am.settings.change_slides_speed * 1000,
          disableOnInteraction: false,
        };
      }
      let swiper = new Swiper(am.$el, sw_options);
    }
  }));

  Alpine.data('ProductCardActions', () => ({
    product: {},
    variant: {},
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
      am.variant = JSON.parse(am.$el.dataset.variant);
    },
    e_UpdateVariant(e) {
      let am = this;
      am.variant = am.product.variants.find(v => v.id == e.target.dataset.variantId);
    },
    async e_AddToCart() {
      let am = this;
      let items_to_add = [{
        quantity: 1,
        id: am.variant.id
      }];
      let sections = 'drawer-cart-items,drawer-cart-footer,cart-item-count';
      
      let add_res = await _UTILS.AddItemsToCart(items_to_add, sections).then(res => res.json());
      // console.log(add_res)
      let event_data = add_res.items[0];
      event_data.sections = add_res.sections;

      // console.log(event_data)
      _UTILS.RefreshCart(event_data);
    }
  }));

  Alpine.data('InfiniteLoader', () => ({
    cache: {},
    paginate: null,
    section_id: '',
    flags: {
      loadNextPage: false,
      allPagesLoaded: false
    },
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
      am.CheckStatus();
    },
    InitSelf() {
      let am = this;
      am.paginate = JSON.parse(am.$el.dataset.paginate);
      am.section_id = am.$el.dataset.section_id;
      am.cache.$section = am.$el.closest('.collection-items');

      _UTILS.ObserveIntersection(am.$el, {}, (entries) => {
        let entry = entries[0];
        // console.log(entry, am.paginate);
        am.flags.loadNextPage = !am.flags.allPagesLoaded && entry.isIntersecting;
      });
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.loadNextPage', am.LoadNextPage.bind(am));
      am.$watch('paginate', am.CheckStatus.bind(am));
    },
    CheckStatus() {
      let am = this;
      am.flags.allPagesLoaded = am.paginate.current_page >= am.paginate.pages;
    },
    async LoadNextPage() {
      let am = this;
      if (!am.flags.loadNextPage) return;

      let nextPageUrl = `${am.paginate.next.url}&section=${am.section_id}`;
      let res = await fetch(nextPageUrl).then(res => res.text());
      let $res = _UTILS.ConvertStringToHTML(res);

      let $products = $res.querySelectorAll('.product-card');
      let $pagination = $res.querySelector('.pagination-infinite');

      // console.log($products)

      // add products
      $products.forEach(($product, index) => {
        am.cache.$section.querySelector('#facets-results ul').insertAdjacentElement('beforeend', $product);
        if (index == $products.length - 1) {
          am.paginate = JSON.parse($pagination.dataset.paginate);
        }
      });

      // render card images
      document.dispatchEvent(new CustomEvent('shopify:section:load'))
    }
  }));

  // Accessibility fixes
  document.querySelectorAll('a[href*="contact-us"]').forEach(($item) => {
    $item.setAttribute('aria-label', 'Contact Us');
  });

  document.querySelectorAll('a[href*="privacy-policy"]').forEach(($item) => {
    $item.setAttribute('aria-label', 'Privacy Policy');
  });

  document.querySelectorAll('a[href*="returns"]').forEach(($item) => {
    $item.setAttribute('aria-label', 'Returns');
  });

  document.querySelectorAll('a[aria-controls="accordion-process-time"]').forEach(($item) => {
    $item.removeAttribute('aria-controls');
    $item.removeAttribute('aria-expanded');
  });
});